<div class="flex flex-col gap-4 text-sm">
  <div class="flex items-center gap-4">
    <h4 class="font-bold text-primary-purple">
      {{ literalService.get('notificationSettings.texts.title') }} · {{ literalService.get('notificationSettings.events.' + event()) }}
    </h4>
    <label class="ml-auto flex items-center gap-2">
      <span class="text-neutrals-grey-04">{{ literalService.get('notificationSettings.texts.language') }}</span>
      <select class="select select-sm" [value]="selectedLanguage" (change)="selectLanguage($any($event.target).value)">
        @for (language of languages; track language) {
          <option [value]="language" [selected]="language === selectedLanguage">{{ literalService.get('languages.' + language, true) }}</option>
        }
      </select>
    </label>
  </div>
  <p class="text-neutrals-grey-04">{{ literalService.get('notificationSettings.texts.intro') }}</p>

  @for (text of eventTexts(); track text.key) {
    @let unknownVariables = getUnknownVariables(text);
    <div class="flex flex-col gap-2 border-b border-neutrals-grey-01 pb-4">
      <div class="flex items-center gap-2">
        <span class="font-semibold">{{ getUsagesLabel(text) }}</span>
        <button
          type="button"
          class="ml-auto text-xs text-primary-purple underline cursor-pointer disabled:cursor-default disabled:text-neutrals-grey-03 disabled:no-underline"
          [disabled]="isDefault(text)"
          (click)="restoreDefault(text)"
        >
          {{ literalService.get('notificationSettings.texts.restoreDefault') }}
        </button>
      </div>
      @if (text.events.length > 1) {
        <p class="text-xs text-neutrals-grey-04">{{ literalService.get('notificationSettings.texts.shared', false, { events: getSharedEventsLabel(text) }) }}</p>
      }
      <textarea
        #textarea
        [id]="'notification-text-' + text.key"
        class="textarea w-full"
        [ngClass]="{ 'border-secondary-red': unknownVariables.length > 0 }"
        [rows]="3"
        [value]="getValue(text)"
        (input)="setValue(text, textarea.value)"
      ></textarea>
      @if (text.variables.length > 0) {
        <div class="flex flex-wrap items-center gap-2">
          <span class="text-xs text-neutrals-grey-04">{{ literalService.get('notificationSettings.texts.variables') }}</span>
          @for (variable of text.variables; track variable) {
            <button
              type="button"
              class="badge badge-sm border-none bg-primary-purple/10 text-primary-purple cursor-pointer hover:bg-primary-purple/20"
              (click)="insertVariable(text, variable, textarea)"
            >
              {{ formatVariable(variable) }}
            </button>
          }
        </div>
      }
      @if (unknownVariables.length > 0) {
        <p class="text-xs text-secondary-red">
          {{ literalService.get('notificationSettings.texts.unknownVariables', false, { variables: formatVariables(unknownVariables) }) }}
        </p>
      }
    </div>
  }

  <div class="sticky bottom-0 flex items-center justify-end gap-4 bg-white pt-2">
    @if (getLanguagesWithUnknownVariables().length > 0) {
      <p class="text-xs text-secondary-red mr-auto">
        {{ literalService.get('notificationSettings.texts.invalidLanguages', false, { languages: getLanguagesWithUnknownVariablesLabel() }) }}
      </p>
    }
    <button type="button" class="secondary border-2 h-10 px-6 font-semibold uppercase cursor-pointer bg-white" (click)="closed.emit()">{{ literalService.get('cancel', true) }}</button>
    <button
      type="button"
      class="primary border-2 h-10 px-6 font-semibold uppercase cursor-pointer"
      [disabled]="saving || getLanguagesWithUnknownVariables().length > 0"
      (click)="save()"
    >
      {{ literalService.get('save', true) }}
    </button>
  </div>
</div>
